<template>
  <aside class="main-sidebar">
    <section class="sidebar">
      <ul class="sidebar-menu">
        <!--<li :class="{ active: $route.path === '/home' }">
          <router-link to="/home">
            <i class="fa fa-dashboard"></i>
            <span class="page">{{'dashboard' | translate }}</span>
          </router-link>
        </li>-->
        <template v-if="$store.state.navTree && $store.state.navTree[0]" v-for="nav in $store.state.navTree[0].children">
          <nav-tree :nav="nav" :key="nav.name"></nav-tree>
        </template>
       </ul>
    </section>
  </aside>
</template>
<script>
  import NavTree from "./NavTree";
  export default {
    data () {
      return {
        user: this.$store.getters.user,
        user_image: 'user2-160x160.jpg', // NEED THIS FROM DATABASE
        user_position: 'best front-end developer ever', // THIS TOO,
        activeMenu: {
          admin: false
        }
      }
    },
    methods: {
    },
    components: {
      NavTree
    },
    mounted () {
      this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
        this.activeMenu[collapseId] = isJustShown
      })
    }
  }
</script>
<style scoped>
  .collapsed > .pull-right-container > .when-open,
  .not-collapsed > .pull-right-container > .when-closed {
    display: none;
  }
  .when-closed, .when-open {
    font-family: 'FontAwesome';
    color: currentColor;
    position: relative;
    font-size: 110%;
    opacity: .65;
  }

</style>
